import { createReducer, on } from '@ngrx/store';
import {
    deleteFundSources,
    deleteFundSourcesFailure,
    getFundSources,
    getFundSourcesFailure,
    getFundSourcesSuccess
} from './ping.actions';
import { Action } from '@ngrx/store';
import { IFundSource, IFundSources } from "@classifieds-sell/datalayer";

export interface PingState {
    fundSources?: {
        isLoading: boolean;
        error?: Error;
        item?: IFundSources;
    };
    balance: number;
}

export interface PingPartialState {
    readonly [PING_FEATURE]: PingState;
}

export const pingInitialState: PingState = {
    fundSources: undefined,
    balance: 0
};

export const selectPingFundSources = (state: PingState) =>
    state && state.fundSources && state.fundSources.item;

export const PING_FEATURE = 'ping';

const pingReducer = createReducer(
    pingInitialState,
    on(getFundSources, (state) => ({
        ...state,
        fundSources: {
            isLoading: true
        }
    })),
    on(getFundSourcesSuccess, (state, { fundSources }) => ({
        ...state,
        fundSources: {
            isLoading: false,
            item: fundSources
        },
        balance: fundSources.availableBalance
    })),
    on(getFundSourcesFailure, (state) => ({
        ...state,
        fundSources: {
            isLoading: false,
            item: [] as IFundSources
        }
    })),
    on(deleteFundSources, (state, { fundSource }) => ({
        ...state,
        fundSources: {
            isLoading: false,
            item: {
              availableBalance: state.fundSources.item.availableBalance,
              fundSources: state.fundSources.item.fundSources.filter(
                (fs: IFundSource) => fs !== fundSource
            )} as IFundSources
        }
    })),
    on(deleteFundSourcesFailure, (state, { fundSource }) => ({
        ...state,
        fundSources: {
            isLoading: false,
            item: {
              availableBalance: state.fundSources.item.availableBalance,
              fundSources: state.fundSources.item.fundSources.filter(
                (fs: IFundSource) => fs !== fundSource
              )} as IFundSources
        }
    }))
);

export function pingReducerFunc(state: PingState | undefined, action: Action) {
    return pingReducer(state, action);
}
